export default "__VITE_ASSET__9ab60d45__"